var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"width":"70%"},on:{"close":_vm.close}},[(_vm.affectedId)?_c(!_vm.isExtranet ? 'binnacle' : 'extranet-binnacle',{tag:"component",attrs:{"affectedId":_vm.affectedId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/pages/WorkPlan/WeeklyExecution/BinnacleModal.vue